// react
import React from 'react'
// antd-pro
import {ProFormSelect, ProFormText} from '@ant-design/pro-components'
import Api from '@/api'
import {AppType} from '@/enum'

/**
 * 合思配置表单项
 * @constructor
 */
const YUNZJFormItems = () => {
  return (
    <>
      <ProFormText
        name={["config", "eid"]}
        label={"Eid"}
        placeholder={"请输入eid"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入eid"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "appId"]}
        label={"Appid"}
        placeholder={"请输入appid"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入appid"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "secret"]}
        label={"Secret"}
        placeholder={"请输入secret"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入secret"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormText
        name={["config", "scope"]}
        label={"Scope"}
        placeholder={"请输入scope"}
        required
        width={"lg"}
        rules={[
          {
            required: true,
            message: "请输入scope"
          },
          {
            pattern: /^[^\s]*$/,
            message: '禁止输入空格',
          }
      ]}
      />
      <ProFormSelect
        name={["config", "envId"]}
        label={"环境地址"}
        placeholder={"请选择所属环境地址"}
        required
        width={"lg"}
        rules={[{
          required: true,
          message: "请选择所属环境地址"
        }]}
        fieldProps={{
          fieldNames: {
            label: "envName",
            value: "id"
          }
        }}
        request={async () => {
          const _data: any = await Api.Common.EnvList({appType: AppType.YUNZJ})
          return _data
        }}
      />
      <ProFormText
        name={["config", "remark"]}
        label={"remark"}
        placeholder={"请输入remark"}
        width={"lg"}
        rules={[
          {
            message: "请输入remark"
          }
      ]}
      />
    </>
  )
}

export default YUNZJFormItems
